/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState } from "react";
import { postApi } from "../../../redux/api";
import { useLocation, useNavigate } from "react-router-dom";
import { useSelector } from "react-redux";
import { Button, Col, Row } from "@themesberg/react-bootstrap";
import { Alert, Modal } from "react-bootstrap";
import CustomButton from "../../../components/CustomButton";
import { Routes } from "../../../routes";
import toast from "react-hot-toast";
import BackButton from "../../../components/BackButton";
import useQuery from "../../../hooks/useQuery";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faEye } from "@fortawesome/free-solid-svg-icons";
import SupportingDocumentsPv from "./SupportingDocuments";
import { OAGOFFICE } from "./PVReviewIndex";
import Trailbalance from "./HtmlPvPdf";
import { ExactPVPDF } from "./ExactPVPDF";
import { pdf } from "@react-pdf/renderer";
import { saveAs } from "file-saver";

export default function PvPdfPage() {
  const query = useQuery();
  const mda_type = query.get("mda_type") || "";
  const user = useSelector((state) => state.auth.user);
  const isSelfSustained = mda_type === "self-sustaining" // user.isSelfSustained;
  const approval_no_raw = query.get("approval_no");
  const approval_no = (!approval_no_raw || approval_no_raw === "null" || approval_no_raw === "undefined") ? null : approval_no_raw;
  const pv_code = query.get("pv_code") || "";
  const approval_type = query.get("approval_type");
  const history = useNavigate();
  const location = useLocation();
  const isReport = location.pathname.includes("report");
  const isReview = location.pathname.includes("review");
  const isEdit = location.pathname.includes("generated");
  // const isAdCheck = location.pathname.includes("checkad");
  const isCheck = location.pathname.includes("check");
  const isApprove = location.pathname.includes("approve");
  const isDAG = isApprove && user.mda_name === OAGOFFICE;
  const isIndividual = location.pathname.includes("individual");

  const [pvInfo, setPvInfo] = useState([]);
  const [taxes, setTaxes] = useState([]);
  const [multiplePVsData, setMultiplePVsData] = useState(null);
  const [isCapitalProject, setIsCapitalProject] = useState(false);
  const [capitalProjectData, setCapitalProjectData] = useState(null);
  const [dataLoading, setDataLoading] = useState(false);
  const [showWarning, setShowWarning] = useState(false);
  const [remarks, setRemarks] = useState("");
  const [approving, setApproving] = useState(false);
  const [commentExpanded, setCommentExpanded] = useState(false);
  const [commentObj, setCommentObj] = useState({});
  const [error, setError] = useState(null);
  const [downloadingPdf, setDownloadingPdf] = useState(false);

  useEffect(() => {
    // alert(approval_no)
    // Validate required parameters - check approval_no first, then pv_code
    if (!approval_no && !pv_code) {
      setError("Missing approval number or PV code parameter");
      toast.error("Invalid URL: Missing required parameters");
      return;
    }

    if (approval_type === "undefined" || approval_type === null) {
      console.warn("Approval type is undefined, proceeding with default handling");
    }

    setDataLoading(true);
    setError(null);

    // Determine which identifier to use
    const searchParam = pv_code || approval_no;

    // Check if this is a capital project first
    if (approval_type === "Capital" || approval_type === "Recurrent") {
      // Use the new capital project API
      postApi(`get_pv_data`, {
        ...(approval_no && { approval_no }),
        pv_code: searchParam,
      })
        .then((data) => {
          if (data?.success) {
            setIsCapitalProject(true);
            setCapitalProjectData(data.result);
            setPvInfo(data?.result?.mainPV ? [data?.result?.mainPV] : []);
            setTaxes(data?.result?.taxes || []);
          } else {
            setError("No PV data found for this approval");
            toast.error("PV not found");
          }
        })
        .catch((err) => {
          console.log(err, "err from capital project");
          setError("Failed to load capital project PV data");
          toast.error("Failed to load capital project PV data");
        })
        .finally(() => setDataLoading(false));
    } else {
      // Use existing logic for standard PVs
      const queryType = (isIndividual || !approval_no)
        ? "select_by_pvcode"
        : isReport
          ? "pv_by_approval_report"
          : "pv_by_approval";

      const pvStatus = !approval_no
        ? "Created"
        : isApprove
          ? "Reviewed"
          : isReview
            ? "Checked"
            : isEdit
              ? "Created"
              : "Pending";

      postApi(`get_pv_collection`, {
        form: {
          query_type: queryType,
          ...(approval_no && { approval_no }),
          pv_status: pvStatus,
          mda_code: user?.mda_code,
          mda_type,
          pv_code: searchParam,
        },
      })
        .then((data) => {
          if (data?.result && data?.result.length) {
            console.log(data.result[0].history, 'datatatatatatatatatat')
            setPvInfo(data?.result);
            const filteredStatus = `${pvStatus} - Returned`;
            let comm = data?.result[0].history.filter(
              (a) => a?.pv_status === filteredStatus
            );
            console.log(comm, 'datatatatatatatatatat')

            if (comm && comm.length) {
              setCommentObj(comm[0]);
            }
          } else {
            setError("No PV data found for this approval");
            toast.error("PV not found");
          }
        })
        .catch((err) => {
          console.log(err);
          setError("Failed to load PV data");
          toast.error("Failed to load PV data");
        })
        .finally(() => setDataLoading(false));
    }
  }, [approval_no, pv_code, approval_type]);

  useEffect(() => {
    const searchParam = pv_code || approval_no;

    if (!searchParam || dataLoading) {
      return; // Don't make API call if no identifier or already loading
    }

    postApi(`get_pv_collection`, {
      form: {
        query_type: "taxes_by_approval",
        approval_no: approval_no || searchParam,
        mda_name: user?.mda_name, mda_code: user?.mda_code || "",
        mda_type
      },
    })
      .then((data) => {
        console.log("Multiple PVs data", data);
        if (data?.result && data?.result.type === 'multiple_pvs') {
          // Handle new multiple PVs structure
          const { main_pv, tax_pvs, taxes } = data.result;
          setPvInfo([main_pv]); // Set main PV as primary display
          setTaxes(taxes || []);
          setMultiplePVsData(data.result); // Store complete multiple PVs data
        } else if (data?.result && data?.result.length) {
          // Handle legacy single taxes response
          setTaxes(data?.result);
        }
      })
      .catch((err) => {
        console.log(err);
        // Don't show error toast here as taxes might not exist
      });
  }, [pv_code, approval_no, dataLoading]);

  const toggleWarning = () => setShowWarning((p) => !p);

  const handleReturn = async () => {
    setApproving(true);
    for (let pv of pvInfo) {
      await postApi(`post_pv_collection`, {
        form: {
          query_type: "update_cash_backing",
          pv_code: pv.pv_code,
          approval_no: pv.pv_code,
          pv_status: isReview
            ? "Pending - Returned"
            : isCheck
              ? "Created - Returned"
              : "Checked - Returned",
          userId: user.username,
          remarks,
        },
      });
    }

    toggleWarning();
    toast.success("PV Returned Successfully!");
    if (isReview) {
      history(Routes.pv.pvReviewIndex);
    } else if (isCheck) {
      history(Routes.pv.pvCheckIndex);
    } else {
      history(Routes.pv.pvApproveIndex);
    }
  };

  // const getpvHistory = useCallback(() => {
  //   postApi(`get_pv_collection`, {
  //     query_type: "get_history",
  //     pv_code: pv_code,
  //   })
  //     .then((data) => {
  //       console.log("History data", data);
  //       if (data?.result && data?.result.length) {
  //         setpvHistory(data.result);
  //       }
  //     })
  //     .catch((err) => {
  //       console.log("This is the Error that occurred", err);
  //     });
  // }, [pv_code]);

  // useEffect(() => {
  //   getpvHistory();
  // }, [getpvHistory]);

  useEffect(() => {
    const searchParam = pv_code || approval_no;

    if (searchParam) {
      setDataLoading(true);
      postApi(`get_pv_collection`, {
        form: {
          query_type: "get_history",
          approval_no: searchParam,
          mda_name: user?.mda_name, mda_code: user?.mda_code || "",
          mda_type
        },
      })
        .then((data) => {
          console.log("My History", data);
          // History data loaded but not used in current implementation
        })
        .catch((err) => {
          console.log(err);
          // Don't show error toast for history as it's not critical
        })
        .finally(() => setDataLoading(false));
    }
  }, [approval_no, pv_code]);

  const handleApprove = async () => {
    setApproving(true);
    for (let pv of pvInfo) {
      // Determine pv_status based on conditions
      let pvStatus;
      let notif_key;

      // Check if user is from self-accounting MDA and is approving
      if ((isSelfSustained === 'true' || isSelfSustained === true) && isApprove) {
        // Self-accounting MDA approval
        pvStatus = "SA_approved";
      } else if ((isSelfSustained === 'true' || isSelfSustained === true) && isReview) {
        // Self-accounting MDA approval
        pvStatus = "MDA Reviewed";
      } else if ((isSelfSustained === 'true' || isSelfSustained === true) && isCheck) {
        // Self-accounting MDA approval
        pvStatus = "MDA Checked";
      } else if (isDAG) {
        // DAG approval
        pvStatus = "DAG Approved";
        notif_key = "Receiving Office"
      } else if (isReview) {
        pvStatus = "Reviewed";
        notif_key = "Approve PV"
      } else if (isCheck) {
        pvStatus = "Checked";
        notif_key = "Review PV"
      } else {
        pvStatus = "Approved";
        notif_key = "Receiving Office"
      }

      await postApi(`post_pv_collection`, {
        form: {
          query_type: "update_cash_backing",
          pv_code: pv.pv_code,
          approval_no: pv.pv_code,
          pv_status: pvStatus,
          userId: user.username,
          remarks,
          notif_key
        },
      });
    }

    // setTimeout(() => {
    toast.success("PV Approved Successfully!");
    if (isReview) {
      history(Routes.pv.pvReviewIndex);
    } else if (isCheck) {
      history(Routes.pv.pvCheckIndex);
    } else {
      history(Routes.pv.pvApproveIndex);
    }
    // }, 2000);
  };

  const downloadPdf = async () => {
    try {
      setDownloadingPdf(true);

      // Determine which data structure to use
      let pdfData = null;
      let pdfTaxes = taxes || [];
      let pdfMultiplePVsData = null;

      // Check if we have multiple PVs data
      if (multiplePVsData) {
        pdfMultiplePVsData = multiplePVsData;
      } else if (taxes && taxes.length > 0 && pvInfo && pvInfo.length > 0) {
        // Create multiple PVs structure from current data
        const totalTaxAmount = taxes.reduce((sum, tax) => sum + parseFloat(tax.amount || 0), 0);
        const grossAmount = parseFloat(pvInfo[0]?.amount || 0);
        const netAmount = grossAmount - totalTaxAmount;

        pdfMultiplePVsData = {
          main_pv: {
            ...pvInfo[0],
            pv_type: 'main',
            original_amount: grossAmount,
            net_amount: netAmount,
            tax_details: taxes
          },
          tax_pvs: taxes.map((tax, index) => ({
            ...pvInfo[0],
            pv_code: `${pvInfo[0]?.pv_code}-TAX-${index + 1}`,
            pv_type: 'tax',
            tax_name: tax.description,
            tax_amount: tax.amount,
            amount: tax.amount,
            narration: `Tax: ${tax.description}`,
            description: `Tax: ${tax.description}`,
            parent_pv_code: pvInfo[0]?.pv_code,
            tax_details: [tax]
          })),
          total_pvs: 1 + taxes.length,
          taxes: taxes,
          type: 'multiple_pvs'
        };
      } else {
        pdfData = pvInfo;
      }

      // Use the ExactPVPDF component that matches HTML layout exactly
      const blob = await pdf(
        <ExactPVPDF
          data={pdfData}
          taxesApplied={pdfTaxes}
          user={user}
          isCapitalProject={isCapitalProject}
          capitalProjectData={capitalProjectData}
          multiplePVsData={pdfMultiplePVsData}
        />
      ).toBlob();

      const fileName = pdfMultiplePVsData
        ? `pv-${pv_code}-with-taxes.pdf`
        : `pv-${pv_code || 'document'}.pdf`;

      saveAs(blob, fileName);

      const pvCount = pdfMultiplePVsData ? pdfMultiplePVsData.total_pvs : 1;
      toast.success(`PDF downloaded successfully! (${pvCount} PV${pvCount > 1 ? 's' : ''})`);
    } catch (error) {
      console.error("Error generating PDF:", error);
      toast.error("Failed to generate PDF. Please try again.");
    } finally {
      setDownloadingPdf(false);
    }
  };

  if (dataLoading) {
    return (
      <div className="pv-paper-view">
        <div className="pv-paper-container">
          <div className="pv-paper-sheet">
            <div className="text-center py-5">
              <div className="spinner-border text-primary" role="status">
                <span className="sr-only">Loading...</span>
              </div>
              <p className="mt-3 text-muted">Loading PV data...</p>
            </div>
          </div>
        </div>
      </div>
    );
  }

  if (error) {
    return (
      <div className="pv-paper-view">
        <div className="pv-paper-container">
          <div className="pv-paper-sheet">
            <Alert variant="danger">
              <Alert.Heading>Error Loading PV Report</Alert.Heading>
              <p>{error}</p>
              <hr />
              <div className="d-flex justify-content-between">
                <BackButton />
                <Button
                  variant="outline-danger"
                  onClick={() => window.location.reload()}
                >
                  Retry
                </Button>
              </div>
            </Alert>
          </div>
        </div>
      </div>
    );
  }

  if (pvInfo && pvInfo.length) {
    return (
      <>
        {/* {JSON.stringify({isAdCheck})}..xx */}
        {/* {JSON.stringify({commentObj,
          ll: `${isApprove ? "Reviewed" : isReview ? "Checked" : "Pending"} - Returned`
        })}..xx */}
        <div className="pv-header-controls">
          <BackButton num={-1} />
          {(isEdit || isReport) ? (
            <div className="mb-1">
              <button
                className="pv-action-button me-2 py-2 rounded"
                onClick={() =>
                  history(
                    `${Routes.cashBacking.releaseCollectionHTML}${approval_no ? `?approval_no=${encodeURIComponent(approval_no)}` : ''}`
                  )
                }
              >
                <FontAwesomeIcon icon={faEye} className="me-1" />
                View Release Document
              </button>
              {isEdit && (
                <Button
                  onClick={() => history(`${Routes.pv.editnewPv}?${approval_no ? `approval_no=${encodeURIComponent(approval_no)}&` : ''}approval_type=${encodeURIComponent(approval_type || '')}&pv_code=${encodeURIComponent(pv_code)}`)}
                >
                  <FontAwesomeIcon icon={"pencil"} size="lg" />
                  Edit PV
                </Button>
              )}
            </div>
          ) : null}
        </div>

        {/* Paper Document Container */}

        <div className="">
          {isReview || isCheck || isApprove ? (
            <div className="pv-action-section">
              <Row>
                <Col md={7}>
                  {commentObj?.remarks && commentObj.remarks !== "" ? (
                    <div className="pv-return-info-card">
                      <div className="return-info-header">
                        <h6>Return Information</h6>
                      </div>
                      <div className="return-info-body">
                        <p className="return-remarks">{commentObj.remarks}</p>
                        <div className="return-meta">
                          <span className="returned-by">
                            Returned by: <strong>{commentObj.fullname}</strong>
                          </span>
                          {commentObj.updated_at && (
                            <span className="return-date">
                              {new Date(commentObj.updated_at).toLocaleDateString("en-GB", {
                                day: "numeric",
                                month: "short",
                                year: "numeric",
                              })}
                            </span>
                          )}
                        </div>
                      </div>
                    </div>
                  ) : null}
                </Col>

                <Col md={5} className="text-right">
                  <Button
                    className="btn-danger me-2 my-2"
                    onClick={toggleWarning}
                  >
                    Return
                  </Button>
                  <Button onClick={handleApprove}>Approve</Button>
                </Col>
              </Row>
            </div>
          ) : null}

          {approving ? (
            <div className="pv-loading-overlay">
              <div className="spinner-border text-primary" role="status">
                <span className="sr-only">Processing...</span>
              </div>
              <p className="mt-2">Please wait...</p>
            </div>
          ) : null}

          <Row>
            <Col lg={8} md={12}>
              <div className="pv-document-controls">
                <Button
                  size="sm"
                  className="my-2 pv-download-btn"
                  onClick={downloadPdf}
                  disabled={downloadingPdf}
                >
                  {downloadingPdf ? (
                    <>
                      <div className="spinner-border spinner-border-sm me-2" role="status">
                        <span className="sr-only">Loading...</span>
                      </div>
                      Generating PDF...
                    </>
                  ) : (
                    <>
                      <FontAwesomeIcon icon={faEye} className="me-1" />
                      Download PV PDF
                    </>
                  )}
                </Button>
              </div>

              <>
                {dataLoading ? (
                  <div className="pv-loading-container">
                    <div className="pv-loading-content">
                      <div className="spinner-border text-primary" role="status">
                        <span className="sr-only">Loading...</span>
                      </div>
                      <h5>Loading Payment Vouchers...</h5>
                      <p>Please wait while we prepare your documents</p>
                    </div>
                  </div>
                ) : isCapitalProject && capitalProjectData ? (
                  <CapitalProjectPVView
                    capitalProjectData={capitalProjectData}
                    user={user}
                  />
                ) : multiplePVsData ? (
                  <MultiplePVsView
                    multiplePVsData={multiplePVsData}
                    user={user}
                  />
                ) : taxes && taxes.length > 0 ? (
                  // If we have taxes but no multiplePVsData, create it from current data
                  <MultiplePVsView
                    multiplePVsData={{
                      main_pv: {
                        ...pvInfo[0],
                        pv_type: 'main',
                        original_amount: pvInfo[0]?.amount,
                        net_amount: parseFloat(pvInfo[0]?.amount || 0) - taxes.reduce((sum, tax) => sum + parseFloat(tax.amount || 0), 0),
                        tax_details: taxes
                      },
                      tax_pvs: taxes.map((tax, index) => ({
                        ...pvInfo[0],
                        pv_code: `${pvInfo[0]?.pv_code}-TAX-${index + 1}`,
                        pv_type: 'tax',
                        tax_name: tax.description,
                        tax_amount: tax.amount,
                        amount: tax.amount,
                        narration: `Tax: ${tax.description}`,
                        description: `Tax: ${tax.description}`,
                        parent_pv_code: pvInfo[0]?.pv_code,
                        tax_details: [tax]
                      })),
                      total_pvs: 1 + taxes.length,
                      taxes: taxes,
                      type: 'multiple_pvs'
                    }}
                    user={user}
                  />
                ) : (
                  <Trailbalance
                    form={{}}
                    user={user}
                    data={pvInfo}
                    taxesApplied={taxes}
                    isMultiplePVs={false}
                    showTaxSummary={false}
                  />
                )}
              </>
            </Col>

            <Col lg={4} md={12}>
              <div className="pv-supporting-docs">
                <SupportingDocumentsPv pvInfo={pvInfo} />
              </div>
            </Col>
          </Row>
        </div>

        {/* Modal remains the same */}
        <Modal show={showWarning} onHide={toggleWarning} size="md">
          <Modal.Header>
            <h4>Please provide reason for return <span style={{color: '#dc3545'}}>*</span></h4>
          </Modal.Header>
          <Modal.Body>
            <textarea
              className="form-control"
              placeholder="Reason for return"
              rows={10}
              value={remarks}
              onChange={({ target: { value } }) => setRemarks(value)}
            />
            {remarks.trim() === "" && (
              <small style={{color: '#dc3545'}}>Reason for return is required</small>
            )}
          </Modal.Body>
          <Modal.Footer>
            <button className="btn btn-danger" onClick={toggleWarning}>
              Cancel
            </button>
            <CustomButton
              onClick={handleReturn}
              disabled={remarks.trim() === ""}
            >
              Return
            </CustomButton>
          </Modal.Footer>
        </Modal>

        {/* Paper-like styling */}
        <style jsx>{`
          .pv-paper-view {
            min-height: 100vh;
            background: linear-gradient(135deg, #f5f7fa 0%, #c3cfe2 100%);
            padding: 20px 0;
          }
          
          .pv-header-controls {
            max-width: 1400px;
            margin: 0 auto;
            display: flex;
            justify-content: space-between;
            align-items: center;
            margin-bottom: 20px;
          }
          
          .pv-action-button {
            background-color: #ffc107;
            border: none;
            color: #212529;
            padding: 8px 16px;
            border-radius: 6px;
            cursor: pointer;
            font-weight: 500;
            transition: all 0.3s ease;
            box-shadow: 0 2px 4px rgba(0,0,0,0.1);
          }
          
          .pv-action-button:hover {
            background-color: #e0a800;
            transform: translateY(-1px);
            box-shadow: 0 4px 8px rgba(0,0,0,0.15);
          }
          
          .pv-paper-container {
            max-width: 1400px;
            margin: 0 auto;
            padding: 0 20px;
          }
          
          .pv-paper-sheet {
            background: #ffffff;
            border-radius: 12px;
            box-shadow: 
              0 4px 6px rgba(0, 0, 0, 0.07),
              0 1px 3px rgba(0, 0, 0, 0.1),
              inset 0 1px 0 rgba(255, 255, 255, 0.1);
            padding: 30px;
            margin-bottom: 30px;
            position: relative;
            border: 1px solid #e1e5e9;
            overflow: hidden;
          }
          
          .pv-paper-sheet::before {
            content: '';
            position: absolute;
            top: 0;
            left: 60px;
            width: 2px;
            height: 100%;
            background: linear-gradient(to bottom, #ff6b6b 0%, #ff6b6b 50%, transparent 50%);
            background-size: 2px 20px;
            opacity: 0.3;
          }
          
          .pv-paper-sheet::after {
            content: '';
            position: absolute;
            top: 0;
            left: 0;
            right: 0;
            height: 40px;
            background: repeating-linear-gradient(
              90deg,
              transparent,
              transparent 19px,
              #e1e5e9 19px,
              #e1e5e9 21px
            );
            opacity: 0.5;
          }
          
          .pv-return-info-card {
            background: #d4edda;
            border: 1px solid #c3e6cb;
            border-radius: 8px;
            overflow: hidden;
            margin-bottom: 0;
          }
          
          .return-info-header {
            background: #c3e6cb;
            padding: 10px 15px;
          }
          
          .return-info-header h6 {
            margin: 0;
            color: #155724;
            font-weight: 600;
            font-size: 14px;
          }
          
          .return-info-body {
            padding: 15px;
          }
          
          .return-remarks {
            margin: 0 0 10px 0;
            color: #155724;
            font-size: 14px;
            line-height: 1.5;
          }
          
          .return-meta {
            display: flex;
            justify-content: space-between;
            align-items: center;
            flex-wrap: wrap;
            gap: 8px;
          }
          
          .returned-by {
            color: #155724;
            font-size: 13px;
          }
          
          .returned-by strong {
            font-weight: 600;
          }
          
          .return-date {
            color: #155724;
            font-size: 12px;
            opacity: 0.8;
          }
          
          .pv-action-section {
            background: #f8f9fa;
            border-radius: 8px;
            padding: 20px;
            margin-bottom: 30px;
            border: 1px solid #dee2e6;
          }
          
          .pv-loading-overlay {
            position: fixed;
            top: 50%;
            left: 50%;
            transform: translate(-50%, -50%);
            background: rgba(255, 255, 255, 0.95);
            padding: 30px;
            border-radius: 12px;
            text-align: center;
            box-shadow: 0 8px 25px rgba(0,0,0,0.15);
            z-index: 1000;
          }
          
          .pv-loading-container {
            display: flex;
            align-items: center;
            justify-content: center;
            height: 100%;
            background: linear-gradient(135deg, #f5f7fa 0%, #c3cfe2 100%);
          }
          
          .pv-loading-content {
            text-align: center;
            background: white;
            padding: 40px;
            border-radius: 12px;
            box-shadow: 0 8px 25px rgba(0,0,0,0.15);
            max-width: 400px;
          }
          
          .pv-loading-content .spinner-border {
            width: 3rem;
            height: 3rem;
            margin-bottom: 20px;
          }
          
          .pv-loading-content h5 {
            color: #495057;
            margin-bottom: 10px;
          }
          
          .pv-loading-content p {
            color: #6c757d;
            margin: 0;
          }
          
          .pv-document-controls {
            margin-bottom: 20px;
            padding-bottom: 5px;
            border-bottom: 2px solid #e9ecef;
            display: flex;
            justify-content: space-between;
            align-items: center;
            flex-wrap: wrap;
            gap: 10px;
          }
          
          .pv-download-btn {
            background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
            border: none;
            color: white;
            padding: 10px 20px;
            border-radius: 6px;
            font-weight: 500;
            transition: all 0.3s ease;
            box-shadow: 0 2px 4px rgba(0,0,0,0.1);
          }
          
          .pv-download-btn:hover {
            transform: translateY(-2px);
            box-shadow: 0 4px 12px rgba(0,0,0,0.15);
          }
          
          .pv-document-wrapper {
            background: #ffffff;
            border: 2px solid #e9ecef;
            border-radius: 8px;
            padding: 0;
            box-shadow: inset 0 2px 4px rgba(0,0,0,0.05);
            height: calc(100vh - 200px);
            overflow: hidden;
          }
          
          .pv-supporting-docs {
            background: #f8f9fa;
            border: 1px solid #dee2e6;
            border-radius: 8px;
            padding: 20px;
            box-shadow: 0 2px 4px rgba(0,0,0,0.05);
            position: sticky;
            top: 20px;
            max-height: calc(100vh - 40px);
            overflow-y: auto;
          }
          
          /* Responsive adjustments */
          @media (max-width: 992px) {
            .pv-paper-container {
              max-width: 100%;
            }
            
            .pv-supporting-docs {
              position: static;
              margin-top: 20px;
              max-height: none;
            }
          }
          
          @media (max-width: 768px) {
            .pv-paper-view {
              padding: 10px 0;
            }
            
            .pv-header-controls {
              flex-direction: column;
              gap: 15px;
              align-items: stretch;
            }
            
            .pv-paper-container {
              padding: 0 10px;
            }
            
            .pv-paper-sheet {
              padding: 20px;
              margin-bottom: 20px;
            }
            
            .pv-paper-sheet::before {
              left: 30px;
            }
            
            .pv-action-section {
              padding: 15px;
            }
            
            .pv-document-wrapper {
              padding: 0;
              min-height: 500px;
            }
            
            .pv-supporting-docs {
              padding: 15px;
            }
            
            .pv-document-controls {
              flex-direction: column;
              align-items: stretch;
            }
          }
          
          @media (max-width: 480px) {
            .pv-paper-sheet {
              padding: 15px;
            }
            
            .pv-document-wrapper {
              min-height: 400px;
            }
          }
          
          /* Print styles */
          @media print {
            .pv-paper-view {
              background: white;
            }
            
            .pv-header-controls,
            .pv-action-section,
            .pv-document-controls,
            .pv-supporting-docs {
              display: none;
            }
            
            .pv-paper-sheet {
              box-shadow: none;
              border: none;
              padding: 0;
            }
            
            .pv-paper-sheet::before,
            .pv-paper-sheet::after {
              display: none;
            }
            
            .pv-document-wrapper {
              border: none;
              box-shadow: none;
              padding: 0;
            }
          }
          
          /* Scrollbar styling for better UX */
          .pv-grid::-webkit-scrollbar,
          .pv-supporting-docs::-webkit-scrollbar {
            width: 6px;
          }
          
          .pv-grid::-webkit-scrollbar-track,
          .pv-supporting-docs::-webkit-scrollbar-track {
            background: #f1f1f1;
            border-radius: 3px;
          }
          
          .pv-grid::-webkit-scrollbar-thumb,
          .pv-supporting-docs::-webkit-scrollbar-thumb {
            background: #c1c1c1;
            border-radius: 3px;
          }
          
          .pv-grid::-webkit-scrollbar-thumb:hover,
          .pv-supporting-docs::-webkit-scrollbar-thumb:hover {
            background: #a8a8a8;
          }
        `}</style>
      </>
    );
  } else {
    return (
      <div className="pv-paper-view">
        <div className="pv-paper-container">
          <div className="pv-paper-sheet">
            <Alert variant="warning">
              <Alert.Heading>No PV Data Found</Alert.Heading>
              <p>No payment voucher data was found for the provided approval number: <strong>{pv_code}</strong></p>
              <hr />
              <div className="d-flex justify-content-between">
                <BackButton />
                <Button
                  variant="outline-warning"
                  onClick={() => window.location.reload()}
                >
                  Refresh
                </Button>
              </div>
            </Alert>
          </div>
        </div>
      </div>
    );
  }
}

// Multiple PVs View Component
const MultiplePVsView = ({ multiplePVsData, user }) => {
  const [searchTerm, setSearchTerm] = useState('');

  if (!multiplePVsData) {
    return <div>No multiple PVs data available</div>;
  }

  const allPVs = [];

  // Handle new multiple main PVs structure
  if (multiplePVsData.pvs_by_main) {
    multiplePVsData.pvs_by_main.forEach((group, groupIndex) => {
      // Add Main PV for this group
      allPVs.push({
        pv: group.main_pv,
        type: 'main',
        taxes: group.taxes,
        title: multiplePVsData.pvs_by_main.length > 1 ? `Main Payment Voucher ${groupIndex + 1}` : 'Main Payment Voucher'
      });

      // Filter tax PVs for this group based on search
      const filteredTaxPVs = group.tax_pvs.filter(pv =>
        pv.tax_name?.toLowerCase().includes(searchTerm.toLowerCase()) ||
        pv.pv_code?.toLowerCase().includes(searchTerm.toLowerCase())
      );

      // Add filtered Tax PVs for this group
      filteredTaxPVs.forEach((taxPV, taxIndex) => {
        allPVs.push({
          pv: taxPV,
          type: 'tax',
          taxes: taxPV.tax_details || [],
          title: taxPV.tax_name || `Tax PV ${groupIndex + 1}-${taxIndex + 1}`
        });
      });
    });
  } else {
    // Fallback for legacy single main PV structure
    const { main_pv, tax_pvs = [], taxes = [] } = multiplePVsData;

    // Filter PVs based on search
    const filteredTaxPVs = tax_pvs.filter(pv =>
      pv.tax_name?.toLowerCase().includes(searchTerm.toLowerCase()) ||
      pv.pv_code?.toLowerCase().includes(searchTerm.toLowerCase())
    );

    allPVs.push({ pv: main_pv, type: 'main', taxes: taxes, title: 'Main Payment Voucher' });
    filteredTaxPVs.forEach((taxPV, index) => {
      allPVs.push({
        pv: taxPV,
        type: 'tax',
        taxes: taxPV.tax_details || [],
        title: taxPV.tax_name || `Tax PV ${index + 1}`
      });
    });
  }

  return (
    <div className="multiple-pvs-container">
      {/* <div className="multiple-pvs-header">
        <div className="header-content">
          <h5>Payment Voucher Collection - {total_pvs} PVs</h5>
          <span className="pv-code">Code: {main_pv?.pv_code}</span>
        </div>
        
        {tax_pvs.length > 3 && (
          <div className="search-bar">
            <input
              type="text"
              placeholder="Search PVs..."
              value={searchTerm}
              onChange={(e) => setSearchTerm(e.target.value)}
              className="pv-search-input"
            />
          </div>
        )}
      </div> */}

      <div className="pv-papers-scroll">
        {allPVs.map((item, index) => (
          <div key={index} className="pv-pfaper-sheet">
            <div className="paper-header">
              <h6>{item.title}</h6>
              <span className={`pv-type-badge ${item.type}`}>
                {item.type === 'main' ? 'PRIMARY' : 'TAX'}
              </span>
            </div>

            <div className="paper-condtent">
              <Trailbalance
                form={{}}
                user={user}
                data={[item.pv]}
                taxesApplied={item.taxes}
                isMultiplePVs={true}
                showTaxSummary={item.type === 'main'}
                isTaxPV={item.type === 'tax'}
              />
            </div>
          </div>
        ))}
      </div>

      <style jsx>{`
        .multiple-pvs-container {
          background: #f8f9fa;
          height: 100%;
          display: flex;
          flex-direction: column;
        }
        
        .multiple-pvs-header {
          background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
          color: white;
          padding: 20px;
          position: sticky;
          top: 0;
          z-index: 100;
          flex-shrink: 0;
        }
        
        .header-content {
          display: flex;
          justify-content: space-between;
          align-items: center;
          margin-bottom: 15px;
        }
        
        .header-content h5 {
          margin: 0;
          font-weight: 600;
        }
        
        .search-bar {
          margin-top: 15px;
        }
        
        .pv-search-input {
          width: 100%;
          max-width: 400px;
          padding: 10px 15px;
          border: none;
          border-radius: 25px;
          background: rgba(255,255,255,0.9);
          font-size: 14px;
          outline: none;
        }
        
        .pv-papers-scroll {
          flex: 1;
          display: flex;
          flex-direction: column;
          gap: 40px;
          overflow-y: auto;
        }
        
        .pv-paper-sheet {
          width: 100%;
          max-width: 1190px; /* A3 width: 297mm ≈ 1190px at 96dpi */
          min-height: 842px; /* A3 height: 210mm ≈ 842px at 96dpi */
          margin: 0 auto;
          background: #ffffff;
          border-radius: 8px;
          box-shadow: 
            0 8px 16px rgba(0,0,0,0.1),
            0 4px 6px rgba(0,0,0,0.05),
            inset 0 1px 0 rgba(255,255,255,0.1);
          position: relative;
          overflow: hidden;
          border: 1px solid #e1e5e9;
          flex-shrink: 0;
        }
        
        .pv-paper-sheet::before {
          content: '';
          position: absolute;
          top: 0;
          left: 60px;
          width: 2px;
          height: 100%;
          background: linear-gradient(to bottom, #ff6b6b 0%, #ff6b6b 50%, transparent 50%);
          background-size: 2px 20px;
          opacity: 0.2;
          z-index: 1;
        }
        
        .pv-paper-sheet::after {
          content: '';
          position: absolute;
          top: 0;
          left: 0;
          right: 0;
          height: 30px;
          background: repeating-linear-gradient(
            90deg,
            transparent,
            transparent 19px,
            #e1e5e9 19px,
            #e1e5e9 21px
          );
          opacity: 0.3;
          z-index: 1;
        }
        
        .paper-header {
          position: relative;
          z-index: 2;
          background: linear-gradient(135deg, #f8f9fa 0%, #e9ecef 100%);
          padding: 20px 30px;
          border-bottom: 2px solid #dee2e6;
          display: flex;
          justify-content: space-between;
          align-items: center;
        }
        
        .paper-header h6 {
          margin: 0;
          color: #495057;
          font-weight: 600;
          font-size: 16px;
        }
        
        .pv-type-badge {
          font-size: 11px;
          padding: 4px 12px;
          border-radius: 15px;
          font-weight: 600;
          text-transform: uppercase;
        }
        
        .pv-type-badge.main {
          background: #d4edda;
          color: #155724;
        }
        
        .pv-type-badge.tax {
          background: #fff3cd;
          color: #856404;
        }
        
        .paper-content {
          position: relative;
          z-index: 2;
          padding: 30px;
          min-height: calc(842px - 80px);
        }
        
        /* Scrollbar styling */
        .pv-papers-scroll::-webkit-scrollbar {
          width: 8px;
        }
        
        .pv-papers-scroll::-webkit-scrollbar-track {
          background: #f1f1f1;
          border-radius: 4px;
        }
        
        .pv-papers-scroll::-webkit-scrollbar-thumb {
          background: #c1c1c1;
          border-radius: 4px;
        }
        
        .pv-papers-scroll::-webkit-scrollbar-thumb:hover {
          background: #a8a8a8;
        }
        
        @media (max-width: 1200px) {
          .pv-paper-sheet {
            max-width: 95%;
            min-height: 700px;
          }
          
          .paper-content {
            padding: 20px;
            min-height: calc(700px - 80px);
          }
        }
        
        @media (max-width: 768px) {
          .pv-papers-scroll {
            padding: 20px 10px;
          }
          
          .pv-paper-sheet {
            min-height: 600px;
          }
          
          .paper-header {
            padding: 15px 20px;
            flex-direction: column;
            gap: 10px;
            align-items: flex-start;
          }
          
          .paper-content {
            padding: 15px;
            min-height: calc(600px - 80px);
          }
          
          .pv-paper-sheet::before {
            left: 30px;
          }
        }
        
        @media print {
          .multiple-pvs-header {
            display: none;
          }
          
          .pv-papers-scroll {
            overflow: visible;
          }
          
          .pv-paper-sheet {
            page-break-after: always;
            box-shadow: none;
            border: 1px solid #000;
          }
          
          .pv-paper-sheet::before,
          .pv-paper-sheet::after {
            display: none;
          }
        }
      `}</style>
    </div>
  );
};

// Capital Project PV View Component
const CapitalProjectPVView = ({ capitalProjectData, user }) => {
  const [searchTerm, setSearchTerm] = useState('');

  if (!capitalProjectData) {
    return <div>No capital project data available</div>;
  }

  const { mainPV, taxPVs = [], taxes = [], totalPVs } = capitalProjectData;

  // Filter PVs based on search
  const filteredTaxPVs = taxPVs.filter((pv, index) =>
    taxes[index]?.tax_name?.toLowerCase().includes(searchTerm.toLowerCase()) ||
    pv.pv_code?.toLowerCase().includes(searchTerm.toLowerCase())
  );

  const allPVs = [
    { pv: mainPV, type: 'capital', taxes: taxes, title: 'Capital Project PV' },
    ...filteredTaxPVs.map((taxPV, index) => ({
      pv: taxPV,
      type: 'tax',
      taxes: [taxes[index]],
      title: taxes[index]?.tax_name || `Tax PV ${index + 1}`
    }))
  ];

  return (
    <div className="capital-project-pv-container">
      <div className="capital-project-header">
        <div className="header-content">
          <h5>Capital Project PV Collection - {totalPVs} PVs</h5>
          <span className="pv-code">Code: {mainPV?.pv_code}</span>
        </div>

        {taxPVs.length > 3 && (
          <div className="search-bar">
            <input
              type="text"
              placeholder="Search PVs..."
              value={searchTerm}
              onChange={(e) => setSearchTerm(e.target.value)}
              className="pv-search-input"
            />
          </div>
        )}
      </div>

      <>
        {allPVs.map((item, index) => (
          <div key={index} className="pv-paper-sheet">
            <div className="paper-header">
              <h6>{item.title}</h6>
              <span className={`pv-type-badge ${item.type}`}>
                {item.type === 'capital' ? 'CAPITAL' : 'TAX'}
              </span>
            </div>

            <div className="paper-content">
              <Trailbalance
                form={{}}
                user={user}
                data={[item.pv]}
                taxesApplied={item.taxes}
                isCapitalProject={true}
                showTaxSummary={item.type === 'capital'}
                isTaxPV={item.type === 'tax'}
              />
            </div>
          </div>
        ))}
      </>

      <style jsx>{`
        .capital-project-pv-container {
          background: #f8f9fa;
          height: 100%;
          display: flex;
          flex-direction: column;
        }
        
        .capital-project-header {
          background: linear-gradient(135deg, #ff6b6b 0%, #ee5a24 100%);
          color: white;
          padding: 20px;
          position: sticky;
          top: 0;
          z-index: 100;
          flex-shrink: 0;
        }
        
        .header-content {
          display: flex;
          justify-content: space-between;
          align-items: center;
          margin-bottom: 15px;
        }
        
        .header-content h5 {
          margin: 0;
          font-weight: 600;
        }
        
        .search-bar {
          margin-top: 15px;
        }
        
        .pv-search-input {
          width: 100%;
          max-width: 400px;
          padding: 10px 15px;
          border: none;
          border-radius: 25px;
          background: rgba(255,255,255,0.9);
          font-size: 14px;
          outline: none;
        }
        
        .pv-papers-scroll {
          flex: 1;
          padding: 30px 20px;
          display: flex;
          flex-direction: column;
          gap: 40px;
          overflow-y: auto;
        }
        
        .pv-paper-sheet {
          width: 100%;
          max-width: 1190px; /* A3 width */
          min-height: 842px; /* A3 height */
          margin: 0 auto;
          background: #ffffff;
          border-radius: 8px;
          box-shadow: 
            0 8px 16px rgba(0,0,0,0.1),
            0 4px 6px rgba(0,0,0,0.05),
            inset 0 1px 0 rgba(255,255,255,0.1);
          position: relative;
          overflow: hidden;
          border: 1px solid #e1e5e9;
          flex-shrink: 0;
        }
        
        .pv-paper-sheet::before {
          content: '';
          position: absolute;
          top: 0;
          left: 60px;
          width: 2px;
          height: 100%;
          background: linear-gradient(to bottom, #ff6b6b 0%, #ff6b6b 50%, transparent 50%);
          background-size: 2px 20px;
          opacity: 0.2;
          z-index: 1;
        }
        
        .pv-paper-sheet::after {
          content: '';
          position: absolute;
          top: 0;
          left: 0;
          right: 0;
          height: 30px;
          background: repeating-linear-gradient(
            90deg,
            transparent,
            transparent 19px,
            #e1e5e9 19px,
            #e1e5e9 21px
          );
          opacity: 0.3;
          z-index: 1;
        }
        
        .paper-header {
          position: relative;
          z-index: 2;
          background: linear-gradient(135deg, #ffe0e0 0%, #ffcccc 100%);
          padding: 20px 30px;
          border-bottom: 2px solid #ffb3b3;
          display: flex;
          justify-content: space-between;
          align-items: center;
        }
        
        .paper-header h6 {
          margin: 0;
          color: #c92a2a;
          font-weight: 600;
          font-size: 16px;
        }
        
        .pv-type-badge {
          font-size: 11px;
          padding: 4px 12px;
          border-radius: 15px;
          font-weight: 600;
          text-transform: uppercase;
        }
        
        .pv-type-badge.capital {
          background: #ffe0e0;
          color: #c92a2a;
          border: 1px solid #ff9999;
        }
        
        .pv-type-badge.tax {
          background: #fff3cd;
          color: #856404;
          border: 1px solid #ffc107;
        }
        
        .paper-content {
          position: relative;
          z-index: 2;
          padding: 30px;
          min-height: calc(842px - 80px);
        }
        
        /* Scrollbar styling */
        .pv-papers-scroll::-webkit-scrollbar {
          width: 8px;
        }
        
        .pv-papers-scroll::-webkit-scrollbar-track {
          background: #f1f1f1;
          border-radius: 4px;
        }
        
        .pv-papers-scroll::-webkit-scrollbar-thumb {
          background: #ff6b6b;
          border-radius: 4px;
        }
        
        .pv-papers-scroll::-webkit-scrollbar-thumb:hover {
          background: #ff5252;
        }
        
        @media (max-width: 1200px) {
          .pv-paper-sheet {
            max-width: 95%;
            min-height: 700px;
          }
          
          .paper-content {
            padding: 20px;
            min-height: calc(700px - 80px);
          }
        }
        
        @media (max-width: 768px) {
          .pv-papers-scroll {
            padding: 20px 10px;
          }
          
          .pv-paper-sheet {
            min-height: 600px;
          }
          
          .paper-header {
            padding: 15px 20px;
            flex-direction: column;
            gap: 10px;
            align-items: flex-start;
          }
          
          .paper-content {
            padding: 15px;
            min-height: calc(600px - 80px);
          }
          
          .pv-paper-sheet::before {
            left: 30px;
          }
        }
        
        @media print {
          .capital-project-header {
            display: none;
          }
          
          .pv-papers-scroll {
            overflow: visible;
          }
          
          .pv-paper-sheet {
            page-break-after: always;
            box-shadow: none;
            border: 1px solid #000;
          }
          
          .pv-paper-sheet::before,
          .pv-paper-sheet::after {
            display: none;
          }
        }
      `}</style>
    </div>
  );
};